import React, { useEffect, useState } from 'react';
import api from '../api';

export default function Admin() {
  const [clients, setClients] = useState([]);
  const [showAddClient, setShowAddClient] = useState(false);
  const [showAddCredits, setShowAddCredits] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [form, setForm] = useState({ name:'', email:'', password:'', cost_per_message:'0.50' });
  const [creditForm, setCreditForm] = useState({ amount:'', note:'' });
  const [msg, setMsg] = useState('');

  const loadClients = () => api.get('/admin/clients').then(r => setClients(r.data));
  useEffect(() => { loadClients(); }, []);

  const addClient = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/clients', form);
      setMsg('Client added successfully');
      setShowAddClient(false);
      setForm({ name:'', email:'', password:'', cost_per_message:'0.50' });
      loadClients();
    } catch(err) { setMsg(err.response?.data?.error || 'Error'); }
  };

  const addCredits = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/credits', { user_id: selectedClient.id, ...creditForm });
      setMsg(`₹${creditForm.amount} added to ${selectedClient.name}`);
      setShowAddCredits(false);
      setCreditForm({ amount:'', note:'' });
      loadClients();
    } catch(err) { setMsg(err.response?.data?.error || 'Error'); }
  };

  return (
    <div>
      {msg && <div style={{background:'#e8f5e9',color:'#2e7d32',padding:'10px 16px',borderRadius:'8px',marginBottom:'16px',fontSize:'13px'}}>{msg}</div>}

      <div className="box">
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
          <h3 style={{marginBottom:0}}>Clients ({clients.length})</h3>
          <button className="btn btn-primary btn-sm" onClick={()=>setShowAddClient(true)}>+ Add Client</button>
        </div>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Credits</th>
              <th>Cost/Msg</th>
              <th>Joined</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {clients.length === 0 && (
              <tr><td colSpan="7" style={{textAlign:'center',color:'#aaa',padding:'32px'}}>No clients yet</td></tr>
            )}
            {clients.map((c, i) => (
              <tr key={c.id}>
                <td>{i+1}</td>
                <td>{c.name}</td>
                <td>{c.email}</td>
                <td style={{fontWeight:600,color: parseFloat(c.credits)<100?'#ea4335':'#34a853'}}>₹{parseFloat(c.credits).toFixed(2)}</td>
                <td>₹{c.cost_per_message}</td>
                <td>{new Date(c.created_at).toLocaleDateString('en-IN')}</td>
                <td>
                  <button className="btn btn-success btn-sm" onClick={()=>{ setSelectedClient(c); setShowAddCredits(true); }}>
                    + Credits
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showAddClient && (
        <div className="modal-overlay" onClick={()=>setShowAddClient(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <h3>Add New Client</h3>
            <form onSubmit={addClient}>
              <div className="form-group"><label>Name</label><input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required /></div>
              <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required /></div>
              <div className="form-group"><label>Password</label><input type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} required /></div>
              <div className="form-group"><label>Cost per Message (₹)</label><input type="number" step="0.01" value={form.cost_per_message} onChange={e=>setForm({...form,cost_per_message:e.target.value})} required /></div>
              <div style={{display:'flex',gap:'8px'}}>
                <button className="btn btn-primary" type="submit">Add Client</button>
                <button className="btn" type="button" onClick={()=>setShowAddClient(false)} style={{background:'#eee'}}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showAddCredits && selectedClient && (
        <div className="modal-overlay" onClick={()=>setShowAddCredits(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <h3>Add Credits — {selectedClient.name}</h3>
            <p style={{fontSize:'13px',color:'#888',marginBottom:'16px'}}>Current balance: ₹{parseFloat(selectedClient.credits).toFixed(2)}</p>
            <form onSubmit={addCredits}>
              <div className="form-group"><label>Amount (₹)</label><input type="number" step="0.01" value={creditForm.amount} onChange={e=>setCreditForm({...creditForm,amount:e.target.value})} required /></div>
              <div className="form-group"><label>Note</label><input value={creditForm.note} onChange={e=>setCreditForm({...creditForm,note:e.target.value})} placeholder="e.g. Recharge May 2026" /></div>
              <div style={{display:'flex',gap:'8px'}}>
                <button className="btn btn-success" type="submit">Add Credits</button>
                <button className="btn" type="button" onClick={()=>setShowAddCredits(false)} style={{background:'#eee'}}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
